"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StandardErrorSchema = void 0;
const zod_1 = require("zod");
const base_error_interface_1 = require("./base-error.interface");
/**
 * This schema can be used for generic errors when making a new schema is not necessary.
 **/
exports.StandardErrorSchema = base_error_interface_1.BaseErrorSchema.extend({
    code: zod_1.z.enum(['BAD_REQUEST', 'CONFLICT', 'NOT_FOUND']),
    description: zod_1.z.string(),
});
